<template>
    <b-row v-if="unidadeRegional">
        <b-col sm="12">
            <h5 class="heading-1 mt-4 mb-4">
                <span>Municípios</span>
            </h5>
        </b-col>
        <b-col sm="12" md="6" v-if="$temAcessoView('APPSE-CONS-UR-04')">
            <b-form-group>
                <label>Municípios Disponíveis</label>
                <model-list-select
                    :list="municipiosDisponiveis"
                    option-text="nomeCidade"
                    option-value="codigoCidade"
                    v-model="codigoCidade"
                >
                </model-list-select>
                <b-button
                    variant="success"
                    @click="inserir()"
                    v-if="municipio"
                    class="mt-2"
                    >Inserir Município</b-button
                >
            </b-form-group>
        </b-col>
        <b-col sm="12">
            <app-tabela
                idTabela="tblUnidadeRegionalMunicipios"
                :itens="unidadeRegional.municipios"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="acoes" slot-scope="data">
                    <span
                        class="text-danger"
                        v-if="$temAcessoView('APPSE-CONS-UR-04')"
                    >
                        <i
                            class="fa fa-trash fa-lg icon-button"
                            title="Excluir Município"
                            @click.stop="confirmarExcluir(data)"
                        ></i>
                    </span>
                </template>
            </app-tabela>
        </b-col>
    </b-row>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import UnidadesRegionaisServicos from './UnidadesRegionaisServicos'

export default {
    props: {
        unidadeRegional: {
            type: Object
        }
    },

    components: {
        ModelListSelect
    },

    data() {
        return {
            municipiosDisponiveis: [],
            codigoCidade: null,
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'codigoCidade',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeCidade',
                    label: 'Município',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        obterMunicipiosDisponiveis() {
            this.$store.dispatch('addRequest')
            UnidadesRegionaisServicos.obterMunicipiosDisponiveis(
                this.$route.params.unidadeRegionalId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.municipiosDisponiveis = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        inserir() {
            this.$store.dispatch('addRequest')
            let municipioDto = {
                unidadeRegionalId: this.unidadeRegional.unidadeRegionalId,
                codigoCidade: this.municipio.codigoCidade,
                nomeCidade: this.municipio.nomeCidade
            }
            UnidadesRegionaisServicos.inserirMunicipio(municipioDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.codigoCidade = null
                            this.$emit('obterUnidadeRegionalAtualizada')
                            this.obterMunicipiosDisponiveis()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        confirmarExcluir(municipio) {
            this.$swal({
                title: 'Exclusão de Município',
                html: `Confirma a exclusão do município <b>${municipio.nomeCidade}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluirMunicipio(municipio)
                }
            })
        },

        excluirMunicipio(municipio) {
            this.$store.dispatch('addRequest')
            UnidadesRegionaisServicos.excluirMunicipio(
                municipio.unidadeRegionalMunicipioId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro excluído com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterUnidadeRegionalAtualizada')
                        this.obterMunicipiosDisponiveis()
                    } else {
                        this.$toast.error(
                            'Erro ao excluir anexo.',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        if (this.$temAcessoView('APPSE-CONS-UR-04')) {
            this.obterMunicipiosDisponiveis()
        }
    },

    computed: {
        municipio() {
            if (this.codigoCidade) {
                return this.municipiosDisponiveis.find(
                    (p) => p.codigoCidade == this.codigoCidade
                )
            }
            return null
        }
    }
}
</script>